import { memo } from 'react';

import { type ClipMetadata } from '@air/api';
import { CopyrightIcon } from '@air/design-icons';

import { InfoPanelDetailsSection } from '~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection';
import { InfoPanelDetailValue } from '~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailValue';
import { isStringMetadataType } from '~/utils/iptcDataTypes';

type InfoPanelCopyrightProps = {
  clipMetadata: ClipMetadata[];
};

export const InfoPanelCopyright = memo(({ clipMetadata }: InfoPanelCopyrightProps) => {
  const copyrightNotice = clipMetadata.find((metadata) => metadata.fieldName === 'CopyrightNotice');
  const usageTerms = clipMetadata.find((metadata) => metadata.fieldName === 'UsageTerms');

  if (!copyrightNotice || !isStringMetadataType(copyrightNotice) || !copyrightNotice.data) {
    return null;
  }

  return (
    <InfoPanelDetailsSection Icon={CopyrightIcon} title="Copyright">
      <InfoPanelDetailValue
        value={copyrightNotice.data}
        additionalInfo={usageTerms && isStringMetadataType(usageTerms) ? usageTerms.data : undefined}
      />
    </InfoPanelDetailsSection>
  );
});

InfoPanelCopyright.displayName = 'InfoPanelCopyright';
